"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = exports.SemVer = exports.SemVerFromSelf = exports.SemVerString = exports.semverPattern = void 0;
const effect_1 = require("effect");
const semver_1 = require("semver");
const NAMESPACE = `SemVer`;
exports.semverPattern = '^' +
    '(0|[1-9]\\d*)\\.' + // major
    '(0|[1-9]\\d*)\\.' + // minor
    '(0|[1-9]\\d*)' + // patch
    '(?:-(' + // prerelease prefix
    '(?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*)' + // first prerelease segment
    '(?:\\.(?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*))*' + // additional prerelease segments
    '))?' + // end of prerelease capturing group
    '(?:\\+([0-9a-zA-Z-]+(?:\\.[0-9a-zA-Z-]+)*))?' + // build metadata
    '$';
const SemVerStringArb = FC => FC.stringMatching(new RegExp(exports.semverPattern), { size: 'xsmall' }).filter(str => str.length <= 256);
exports.SemVerString = effect_1.Schema.String.pipe(effect_1.Schema.filter(str => (0, semver_1.valid)(str) !== null, {
    jsonSchema: { pattern: exports.semverPattern, maxLength: 256 },
})).annotations({
    identifier: `${NAMESPACE}.SemVerString`,
    description: 'A Semantic Versioning string',
    documentation: 'https://semver.org',
    examples: ['1.2.3', '1.0.0-rc.1+build_123'],
    arbitrary: () => SemVerStringArb,
});
const SemVerArb = FC => {
    return SemVerStringArb(FC).map(str => new semver_1.SemVer(str), u => (u instanceof semver_1.SemVer ? u.toString() : ''));
};
const semverAnnotations = {
    documentation: 'https://github.com/npm/node-semVer#readme',
    arbitrary: () => SemVerArb,
};
exports.SemVerFromSelf = effect_1.Schema.instanceOf(semver_1.SemVer).annotations({
    identifier: `${NAMESPACE}.SemVerFromSelf`,
    description: 'A SemVer class instance',
    ...semverAnnotations,
});
exports.SemVer = effect_1.Schema.transformOrFail(exports.SemVerString, exports.SemVerFromSelf, {
    strict: true,
    decode: (string, _options, ast) => (0, semver_1.valid)(string)
        ? effect_1.Effect.succeed(new semver_1.SemVer(string))
        : effect_1.Effect.fail(new effect_1.ParseResult.Type(ast, string, 'Invalid semVer string')),
    encode: semVer => effect_1.Effect.succeed(semVer.toString()),
}).annotations({
    identifier: `${NAMESPACE}.SemVer`,
    description: 'A SemVer Class instance created from a SemVer String',
    ...semverAnnotations,
});
exports.Order = effect_1.Order.make((self, that) => self.compare(that));
//# sourceMappingURL=semver.js.map